$(function(){
    initGroupoShow();
})

function initGroupoShow(parent){
    if(isNullOrUndefined(parent)) parent = $("body");
    else if(isUndefined(parent[0])) parent = $(parent);

    $("[group-tabs][group-target]", parent).each(function(i,e){
        $(e).on("click", function(){
            var group = $(e).attr("group-tabs");
            var target = $(e).attr("group-target");

            $("[group-tabs="+group+"][group-target]").removeClass("sel");
            $("[group-tabs="+group+"][group-item]").addClass("hidden");

            $(e).addClass("sel");
            $("[group-tabs="+group+"][group-item="+target+"]").removeClass("hidden");
        });
    })
}